import {Modal, Select} from "antd"
import {error_manager} from "helper/error_manager"
import {post} from "helper/request"
import {Component} from "react"
import cookie from "react-cookies";

const Option = Select.Option;

class ConfirmUserDelete extends Component {
    constructor(props) {
        super(props)

        this.state = {
            confirmLoading: false,
            newOwnerName: '',
            new_owner_options: [],
        }
    }

    componentDidMount() {
        if (Object.keys(this.props.allUsers).length > 0) {
            Object.values(this.props.allUsers).forEach(val => {
                if (!this.props.usernames.includes(val.username) && val.organisation.toString() === cookie.load("organisation_id")) {
                    this.state.new_owner_options.push(<Option value={val.username}>{val.username}</Option>)
                }
            })
        }
    }

    deleteUser = () => {
        this.setState({confirmLoading: true})
        const promises = []

        for (const username of this.props.usernames) {
            const data = {username: username, transfer_to_username: this.state.newOwnerName}
            promises.push(post('/api/delete_user/',data))
        }

        Promise.allSettled(promises)
            .then(results => {
                let errored = false;
                for (const result of results) {
                    if (result.status !== "rejected") continue
                    errored = true;
                    this.props.closeModal(true);
                    let errMsg = result?.reason?.response?.data ? result?.reason?.response?.data :
                        "Failed to delete user, contact Morphle Support";
                    error_manager(errMsg, result?.reason)
                }
                !errored && this.props.closeModal(false);
                this.setState({confirmLoading: false})
            })
    }

    handleOwnerChange = (value) => {
        this.setState({newOwnerName: value});
    }

    render() {
        return (
            <Modal
                title={"Confirm, Delete User(s)"}
                onOk={() => this.deleteUser()}
                onCancel={() => this.props.closeModal(true)}
                confirmLoading={this.state.confirmLoading}
                visible={this.props.showModal}
                okButtonProps={{disabled: this.state.newOwnerName === ''}}
            >
                <div>
                    If user is deleted all data related to user will be lost forever.
                </div>
                <div>
                    {"Do you want to delete following user(s) ?"}
                    <ul>
                        {this.props.usernames?.map(e => (
                            <li>{e}</li>
                        )) || []}
                    </ul>
                </div>
                <div style={{marginBottom: 20, fontSize: 11}}>
                    The selected User(s) are owner to various slides and cases,please transfer the ownership
                    of such properties to some other user, so that data remains unaffected on User(s) delete.
                </div>
                <div>
                    <label>Transfer Ownership to: </label>
                    <Select
                        value={this.state.newOwnerName}
                        placeholder="Filter Devices"
                        onChange={this.handleOwnerChange}
                        style={{width: '50%', marginLeft: 18}}
                        id="ownership_change"
                    >
                        {this.state.new_owner_options}
                    </Select>
                </div>
                <div style={{marginTop: 20, fontStyle: "italic"}}>
                    {this.props.usernames.length === Object.keys(this.props.allUsers).length &&
                        <div>
                            <span style={{color: "#f00"}}>*
                            There must be at least one user in the organisation to which you may transfer the ownership.
                            </span>
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default ConfirmUserDelete